import React from "react";
import { makeStyles, Theme } from "@material-ui/core";
import { Tabs } from "./Tabs";
import { useState } from "react";
import { useLocation } from "react-router-dom";

const TABS_HEIGHT = 30;
const TAB_PREFERENCE_KEY_NAME = "tabPreference";

const useStyles = makeStyles<Theme, { twelfths: number }>((theme) => {
  return {
    root: {
      border: "1px solid red;",
    },
    scrollableArea: ({ twelfths }) => ({
      // the scrollable area is pretty much the full height, minus the header area
      height: `calc(100vh - ${theme.contentOffsets.AFTER_RECORD_HEADER + 75
        }px)`,

      // prevent the area expanding when we make the browser wider than xl
      //  (fits in with the reset of the portal stopping at xl)
      maxWidth: theme.breakpoints.values.xl - 20,
      width: `calc((100vw - ${65}px))`,
      [theme.breakpoints.up("lg")]: {
        position: "fixed",

        // the scrollable area - takes in to account the presence of a menu to establish width
        width: `calc((100vw - ${theme.layoutDimensions.mainDrawerWidth + 80
          }px) * ${twelfths / 12})`,
        // prevent the area expanding when we make the browser wider than xl
        //  (fits in with the reset of the portal stopping at xl)
        maxWidth: theme.breakpoints.values.xl * (twelfths / 12) - 20,
      },
    }),

    inner: {
      position: "relative",
      height: "100%",
      width: "100%",
    },

    content: {
      height: `calc(100% - ${TABS_HEIGHT}px)`,
      // border: "1px solid red/",
      // marginTop: "-15px",
      overflow: "hidden",
      "&::-ms-overflow-style": "none" /* IE and Edge */,
      scrollbarWidth: "none" /* Firefox */,
      "&::-webkit-scrollbar": {
        width: "0px",
        background: "transparent",
        display: "none",
      },
    },
  };
});

type ScrollableAreaTabsProps = {
  tabs: {
    label: React.ReactNode;
    content: React.ReactNode;
    tabTypeId?: string;
    dataTest?: string;
  }[];
  twelfths?: number;
  dataTest?: string;
  defaultTabIx?: number;
};

export const ScrollableAreaTabs: React.FC<ScrollableAreaTabsProps> = ({
  tabs,
  dataTest,
  twelfths = 4,
  defaultTabIx
}) => {
  const classes = useStyles({ twelfths });

  const defaultTabIndex = !!defaultTabIx
    ? defaultTabIx
    : useTryGetDefaultTabIndex(tabs);
  const [currentTabValue, setCurrentTabValue] = useState<number>(
    defaultTabIndex
  );

  const currentTabContent = tabs[currentTabValue].content;
  return (
    <div className={classes.scrollableArea}>
      <div className={classes.inner}>
        <Tabs
          dataTest={dataTest}
          currentTabId={String(currentTabValue)}
          onTabChange={(newTabId: any) => setCurrentTabValue(newTabId)}
          tabs={tabs.map(({ label, dataTest }, index) => ({
            id: String(index),
            label,
            dataTest
          }))}
        />
        <div className={classes.content}>{currentTabContent}</div>
      </div>
    </div>
  );
};

const useTryGetDefaultTabIndex = (tabs: ScrollableAreaTabsProps["tabs"]) => {
  const location = useLocation<{ [key: string]: string } | undefined>();
  const preferredTab = location?.state?.[TAB_PREFERENCE_KEY_NAME];
  if (preferredTab) {
    const foundPreferredTabId = tabs.findIndex(
      (tab) => tab.tabTypeId === preferredTab
    );
    if (foundPreferredTabId !== -1) {
      return foundPreferredTabId;
    }
  }
  return 0;
};
